const from = "0123456789+/=KLMNOPQRSTUVWXYZABCDEFGHIJklmnopqrstuvwxyzabcdefghij";
const to = "TUVWXYZabcABCDEFGHIJKLMNOPQRSdefghijklmnopqrstuvwxyz0123456789+/=";

const characterMap = from.split("").reduce((map, char, index) => {
  map[char] = to[index];

  return map;
}, {});

export const b64DecodeUnicode = (encodedString) => {
  return decodeURIComponent(
    atob(encodedString)
      .split("")
      .map((character) => {
        // biome-ignore lint/style/useTemplate: templates make this much worse
        return "%" + ("00" + character.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(""),
  );
};

export const deobfuscateString = (obfuscatedString) => {
  const mappedString = obfuscatedString
    .split("")
    .map((character) => characterMap[character])
    .join("");

  return b64DecodeUnicode(mappedString);
};
